import { Menu, MenuMulti, type MenuMultiOption } from "@saviynt/design-system";

import usePaginatedFilterMenu from "./use-PaginatedFilterMenu";

interface PaginatedFilterMenuProps {
  field: string;
  label: string;
  selectedValues: string[];
  onChange: (selectedOptions?: MenuMultiOption[] | MenuMultiOption) => void;
  trigger: React.ReactElement;
  isSingleSelect: boolean;
}

function PaginatedFilterMenu({
  field,
  label,
  selectedValues,
  onChange,
  trigger,
  isSingleSelect = false,
}: PaginatedFilterMenuProps) {
  const {
    menuOptions,
    setSearchTerm,
    handleMenuScroll,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    handleMenuExpanded,
  } = usePaginatedFilterMenu(field, selectedValues);

  if (isSingleSelect) {
    return (
      <Menu
        options={menuOptions}
        onChange={(option) => onChange(option as MenuMultiOption)}
        trigger={trigger}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        setIsExpanded={handleMenuExpanded}
      />
    );
  }

  return (
    <MenuMulti
      options={menuOptions}
      onChange={(option) => onChange(option)}
      trigger={trigger}
      onScroll={handleMenuScroll}
      setIsExpanded={handleMenuExpanded}
      label={label}
      minOptionsForFooter={1}
      heightToShowScrollbar="24rem"
      size="medium"
      hasMoreOptions={hasNextPage || isLoading}
      isLoading={isFetchingNextPage || isLoading}
      onSearchTermChange={setSearchTerm}
      minOptionsForSearch={1}
      // In case of loading - we dont have to display no data text
      noDataText={isFetchingNextPage || isLoading ? " " : undefined}
      showOptionLabelOnHover
    />
  );
}

export default PaginatedFilterMenu;
